import React from 'react';
import { Flex } from '../Flex/Flex';
import { Link } from '../Link/Link';
import { Text } from '../Text/Text';
/**
 * @public
 */
export const BreadcrumbLink = React.forwardRef(({
  className,
  isLastChild,
  href,
  icon,
  label,
  onClick
}, ref) => {
  const linkColor = isLastChild ? 'text.dark' : 'text.light';
  return React.createElement(Flex, {
    className: className,
    alignItems: 'center'
  }, icon, React.createElement(Link, {
    href: href,
    color: linkColor,
    onClick: onClick,
    ref: ref
  }, label), !isLastChild && React.createElement(Text, {
    m: 2,
    color: 'text.light'
  }, "/"));
});
BreadcrumbLink.displayName = 'BreadcrumbLink';